/**
 * The backup's way out (D40): on the operator screen the BACKUP serves, when main stops answering (`lib/takeOver.ts`
 * says when), one click takes the production over from main. The click opens the emergency activation's confirmation
 * (the production's name and a reason, with the split-brain warning); without the rights the banner says who can.
 */
import { ShieldAlertIcon } from 'lucide-react';
import { Button } from '../ui/button.js';

export type TakeOverBannerProps = {
  readonly mainNode: string;
  /** Why it is offered: what stopped answering. */
  readonly why: string;
  /** The operator holds `playout.activate` and `node.switchover` on the studio. */
  readonly canTakeOver: boolean;
  readonly pending: boolean;
  readonly onTakeOver: () => void;
};

export function TakeOverBanner({ mainNode, why, canTakeOver, pending, onTakeOver }: TakeOverBannerProps) {
  return (
    <div role="alert" className="flex flex-wrap items-center gap-3 border-b border-destructive bg-destructive px-4 py-2 text-sm text-destructive-foreground" data-testid="take-over">
      <ShieldAlertIcon className="size-4 shrink-0" aria-hidden="true" />
      <span className="min-w-0 flex-1" data-testid="take-over-why">
        <strong>Main is not answering commands</strong> — {why}. This server (the backup) can take the production over from {mainNode}.
        {canTakeOver ? '' : ' Someone with activate and switchover rights on this studio can.'}
      </span>
      {canTakeOver ? (
        <Button size="sm" variant="outline" className="border-destructive-foreground bg-transparent" disabled={pending} onClick={onTakeOver} data-testid="take-over-go">
          {pending ? 'Taking over…' : 'Take over from main'}
        </Button>
      ) : null}
    </div>
  );
}
